// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9d58fd1c","389":"b4bada07","453":"bdbf9b35","455":"545f5460","857":"bbce10e7","977":"5e7415f4"}[chunkId] + ".chunk.js";
};